import { UIText2 } from '@cian/ui-kit';
import { IconActionArrowDown16, IconActionArrowUp16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

interface IShowMoreLinkProps {
  isExpanded: boolean;
  onClick: () => void;
}

export const ReadMore: React.FunctionComponent<IShowMoreLinkProps> = ({ isExpanded, onClick }) => {
  return (
    <div className={styles['read_more']} onClick={onClick} data-testid="read_more">
      <UIText2 color="text-main-default">{isExpanded ? 'Свернуть' : 'Читать дальше'}</UIText2>
      <span className={styles['icon']}>
        {isExpanded ? (
          <IconActionArrowUp16 color="icon-main-default" />
        ) : (
          <IconActionArrowDown16 color="icon-main-default" />
        )}
      </span>
    </div>
  );
};
